module.exports = __webpack_public_path__ + "img/living_room_full.51413897.jpg";